import React from 'react';
import { Card, CardContent, Typography, Button, Box, Chip } from '@mui/material';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import DoneIcon from '@mui/icons-material/Done';

export default function CrawlJobCard({ job, onDelete, onRefresh, onRestart, onMarkCompleted }) {
  // 상태에 따라 재시작 버튼 표시 여부 결정
  // 대소문자 구분 없이 확인하도록 수정
  const status = job.status?.toUpperCase?.() || '';
  const showRestartButton = ["CRAWLING", "PENDING", "crawling", "pending"].includes(status);
  const showMarkCompletedButton = ["CRAWLING", "crawling"].includes(status);
  
  // 상태에 따른 색상 결정
  const getStatusColor = () => {
    switch(status) {
      case 'COMPLETED':
      case 'completed':
        return 'success';
      case 'FAILED':
      case 'failed':
        return 'error';
      case 'CRAWLING':
      case 'crawling':
        return 'primary';
      case 'PENDING':
      case 'pending':
        return 'warning';
      case 'CANCELLED':
      case 'cancelled':
        return 'default';
      default:
        return 'default';
    }
  };

  return (
    <Card sx={{ mb: 2 }}>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          크롤링: {job.url}
        </Typography>
        <Box display="flex" alignItems="center" gap={1} mb={1}>
          <Typography variant="body2" color="text.secondary">
            상태: 
          </Typography>
          <Chip 
            label={status} 
            color={getStatusColor()} 
            size="small" 
            variant="outlined"
          />
          <Typography variant="body2" color="text.secondary">
            | 페이지: {job.pages_crawled} | 파일: {job.files_extracted}
          </Typography>
        </Box>
        <Typography variant="body2" color="text.secondary">
          시작: {job.start_time}
        </Typography>
        {job.end_time && (
          <Typography variant="body2" color="text.secondary">
            종료: {job.end_time}
          </Typography>
        )}
        <Box mt={2} display="flex" gap={1}>
          {onRefresh && (
            <Button size="small" variant="outlined" onClick={() => onRefresh(job.crawl_id)}>
              새로고침
            </Button>
          )}
          {onRestart && showRestartButton && (
            <Button 
              size="small" 
              variant="outlined" 
              color="success" 
              startIcon={<PlayArrowIcon />}
              onClick={() => onRestart(job.crawl_id)}
            >
              재시작
            </Button>
          )}
          {onMarkCompleted && showMarkCompletedButton && (
            <Button 
              size="small" 
              variant="outlined" 
              color="success" 
              startIcon={<DoneIcon />}
              onClick={() => onMarkCompleted(job.crawl_id)}
            >
              완료로 표시
            </Button>
          )}
          {onDelete && (
            <Button size="small" color="error" variant="outlined" onClick={() => onDelete(job.crawl_id)}>
              삭제
            </Button>
          )}
        </Box>
      </CardContent>
    </Card>
  );
} 